import Keypad from "src/components/organisms/Keypad";
import css from "./Pin.module.scss";
import Logo from "src/logos/Logo";

export default function Pin() {
    return (
        <div className={css.page}>
            <Logo width="260px" />
            <Keypad mode="enter"/>
        </div>
    );
}
